import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { EmployeeComponent } from '../employee/employee.component';
import { SalaryComponent } from '../salary/salary.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit {

  public menu_item_id = '26';
  public add_auth;
  public edit_auth;
  public del_auth;

  branchList = [];
  private dp = [];
  displayedColumns = ['employee_no', 'name', 'name_en', 'mobile', 'branch_name', 'national_id',
    'national_id_exp', 'passport_no', 'passport_exp', 'join_date', 'commission', 'activate', 'show',
    'edit', 'del'];
  displayedColumns2 = ['employee_no', 'name', 'name_en', 'mobile', 'branch_name', 'national_id',
    'national_id_exp', 'passport_no', 'passport_exp', 'join_date', 'commission'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<EmployeeComponent>;
  salaryDialogRef: MatDialogRef<SalaryComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'employee', 'employee_no': '', 'name': '', 'mobile': '', 'branch_id': '',
    'national_id': '', 'national_id_exp': new Date(), 'passport_no': '', 'passport_exp': new Date(),
    'join_date': new Date(), 'title': 'قائمة الموظفين'
  };

  Employee_List; Success_Msg; Error_Msg; Del_Msg; Na_Id; National_Id_Exp;
  Passport_No; Passport_Exp; Join_Date; Employee_Name; Employee_No;
  Mobile; Branch;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Employee_List').subscribe((res: string) => {
      this.Employee_List = res;
    });
    this.model['title'] = this.Employee_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Na_Id').subscribe((res: string) => {
      this.Na_Id = res;
    });

    translate.get('National_Id_Exp').subscribe((res: string) => {
      this.National_Id_Exp = res;
    });

    translate.get('Passport_No').subscribe((res: string) => {
      this.Passport_No = res;
    });

    translate.get('Passport_Exp').subscribe((res: string) => {
      this.Passport_Exp = res;
    });

    translate.get('Join_Date').subscribe((res: string) => {
      this.Join_Date = res;
    });

    translate.get('Employee_Name').subscribe((res: string) => {
      this.Employee_Name = res;
    });

    translate.get('Employee_No').subscribe((res: string) => {
      this.Employee_No = res;
    });

    translate.get('Mobile').subscribe((res: string) => {
      this.Mobile = res;
    });

    translate.get('Branch').subscribe((res: string) => {
      this.Branch = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT * FROM `branch` WHERE `status`='1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
      });

    this.model['join_date'] = undefined;
    this.model['national_id_exp'] = undefined;
    this.model['passport_exp'] = undefined;
  }

  search() {

    let condition = "";

    if (this.model['employee_no'] != '')
      condition += " AND `employee`.`employee_no` LIKE '%" + this.model['employee_no'] + "%'";

    if (this.model['name'] != '')
      condition += " AND (`employee`.`name` LIKE '%" + this.model['name'] +
        "%' OR `employee`.`name_en` LIKE '%" + this.model['name'] + "%')";

    if (this.model['mobile'] != '')
      condition += " AND `employee`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['branch_id'] != '')
      condition += " AND `employee`.`branch_id` = '" + this.model['branch_id'] + "'";

    if (this.model['national_id'] != '')
      condition += " AND `employee`.`national_id` LIKE '%" + this.model['national_id'] + "%'";

    if (this.model['passport_no'] != '')
      condition += " AND `employee`.`passport_no` LIKE '%" + this.model['passport_no'] + "%'";

    if (this.model['national_id_exp'] != undefined) {
      let national_id_exp = this.model['national_id_exp'].getFullYear() + "-" +
        (this.model['national_id_exp'].getMonth() + 1) + "-" + this.model['national_id_exp'].getDate();
      condition += " AND `employee`.`national_id_exp` = '" + national_id_exp + "'";
    }

    if (this.model['passport_exp'] != undefined) {
      let passport_exp = this.model['passport_exp'].getFullYear() + "-" +
        (this.model['passport_exp'].getMonth() + 1) + "-" + this.model['passport_exp'].getDate();
      condition += " AND `employee`.`passport_exp` = '" + passport_exp + "'";
    }

    if (this.model['join_date'] != undefined) {
      let join_date = this.model['join_date'].getFullYear() + "-" +
        (this.model['join_date'].getMonth() + 1) + "-" + this.model['join_date'].getDate();
      condition += " AND `employee`.`join_date` = '" + join_date + "'";
    }

    let query = "SELECT `employee`.*, `branch`.`branch_name`, `city`.`country_id` FROM `employee`, `branch`, " +
      "`city` WHERE `employee`.`branch_id` = `branch`.`branch_id` AND `employee`.`city_id` = `city`.`city_id`" +
      condition + " AND `employee`.`status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newEmployeeEntry() {
    this.addDialogRef = this.dialog.open(EmployeeComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // console.log(result);
        // if (result != null && result['status'] == 'success')
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Employee_No + ': ' + this.model['employee_no'] + '</td>';
    html_data += '<td width="33%"> ' + this.Employee_Name + ': ' + this.model['name'] + '</td>';
    html_data += '<td width="33%"> ' + this.Mobile + ': ' + this.model['mobile'] + ' </td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Branch + ': ';
    if (this.model['branch_id'] != '' && this.model['branch_id'] != '0') {
      this.branchList.forEach(element => {
        if (element.branch_id == this.model['branch_id']) {
          html_data += element.branch_name;
          return;
        }
      });
    }
    html_data += '</td>';
    html_data += '<td width="33%"> ' + this.Na_Id + ': ' + this.model['national_id'] + '</td>';
    html_data += '<td width="33%"> ' + this.National_Id_Exp + ': ';
    if (this.model['national_id_exp'] != undefined) {
      html_data += this.model['national_id_exp'].getFullYear() + "-" +
        (this.model['national_id_exp'].getMonth() + 1) + "-" + this.model['national_id_exp'].getDate();
    }
    html_data += '</td></tr>';

    html_data += '<tr><td width="33%"> ' + this.Passport_No + ': ' + this.model['passport_no'] + '</td>';
    html_data += '<td width="33%"> ' + this.Passport_Exp + ': ';
    if (this.model['passport_exp'] != undefined) {
      html_data += this.model['passport_exp'].getFullYear() + "-" +
        (this.model['passport_exp'].getMonth() + 1) + "-" + this.model['passport_exp'].getDate();
    }
    html_data += '</td>';
    html_data += '<td width="33%"> ' + this.Join_Date + ': ';
    if (this.model['passport_exp'] != undefined) {
      html_data += this.model['join_date'].getFullYear() + "-" +
        (this.model['join_date'].getMonth() + 1) + "-" + this.model['join_date'].getDate();
    }
    html_data += '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('emp_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  editEmp(row) {
    // let isrep = 0;
    // if (row.is_rep == '1')
    // isrep = 1;
    let dialog_data = [{
      'table_name': this.model['table_name'], 'employee_id': row.employee_id,
      'employee_no': row.employee_no,
      'name': row.name,
      'name_en': row.name_en,
      'mobile': row.mobile,
      'branch_id': row.branch_id,
      'city_id': row.city_id,
      'national_id': row.national_id,
      'address': row.address,
      'nationality': row.nationality,
      'is_rep': (row.is_rep == '0' ? 0 : 1),
      'bank_name': row.bank_name,
      'bank_acct_number': row.bank_acct_number,
      'wp_no': row.wp_no,
      'wp_exp': row.wp_exp, //'wp_exp_d': new Date(row.wp_exp),
      'occupation_id': row.occupation_id,
      'national_id_exp': row.national_id_exp, //'national_id_exp_d': new Date(row.national_id_exp),
      'passport_no': row.passport_no,
      'passport_exp': row.passport_exp, //'passport_exp_d': new Date(row.passport_exp),
      'join_date': row.join_date, //'join_date_d': new Date(row.join_date), 
      'has_custody': (row.has_custody == '0' ? 0 : 1),
      'custody_acct_number': row.custody_acct_number,
      'has_loan': (row.has_loan == '0' ? 0 : 1),
      'loan_acct_number': row.loan_acct_number,
      'key': 'employee_id',
      'flag': 'update',
      'comment': row.comment
    },
    {
      'country_id': row.country_id,
      'nationality': row.nationality
    },
    {
      'wp_exp_d': new Date(row.wp_exp),
      'national_id_exp_d': new Date(row.national_id_exp),
      'passport_exp_d': new Date(row.passport_exp),
      'join_date_d': new Date(row.join_date)
    }];

    this.addDialogRef = this.dialog.open(EmployeeComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });

  }

  delEmp(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'employee_id': row.employee_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  salary(row) {
    let dialog_data = {
      'employee_id': row.employee_id,
      'employee_no': row.employee_no,
      'name': row.name
    };
    this.salaryDialogRef = this.dialog.open(SalaryComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.salaryDialogRef
      .afterClosed()
      .subscribe(result => {
      });
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}
